import ComponentRegistry from '../components-registry';

import AssetLoader from './asset-loader';

type LoadResult = {
  name: string;
  componentRef: unknown;
};

/**
 * Exposes APIs to load the script files and
 * css files from the script mapping from components_map.js file.
 */

const CUSTOM_COMPONENT_PATH = 'component';
const COMPONENT_LOADER = 'component-loader';

/* TODO: Versioning Support */
const loadedComponents: { [key: string]: boolean } = {};

/**
 * Loads the scripts from dependencies list.
 * It reads the dependency from components map and process
 * the scripts mapped in it.
 * Once all scripts loaded successfully, it call render.
 * @param components components list eq., section...
 * @param staticServer staticServer url
 * @returns promise
 */
const loadComponents = async (components: string[], staticServer?: string): Promise<LoadResult[] | void | object> => {
  if (!components?.length || window.PCore?.getBehaviorOverride('dynamicLoadComponents') === false) {
    return Promise.resolve();
  }

  const loader = AssetLoader.getLoader();
  const staticServerURL = staticServer || AssetLoader.staticServerURL;

  if (AssetLoader.getLoader(COMPONENT_LOADER)) {
    return AssetLoader.getLoader(COMPONENT_LOADER)(components, staticServerURL);
  }

  const loadedSet = new Set(Object.keys(loadedComponents));

  const assetPromises = components.flatMap<Promise<unknown>>((name) => {
    if (loadedSet.has(name)) return [];

    const component = ComponentRegistry.getComponent(name);
    if (!component) {
      // Custom component (not in registry)
      const srcUrl = `${AssetLoader.getConstellationServiceUrl()}/v860/${AssetLoader.getAppAlias()}/${CUSTOM_COMPONENT_PATH}/${name}.js`;
      loadedSet.add(name);
      return [loader(srcUrl, AssetLoader.getTypes.SCRIPT)];
    }

    const scriptPromises = (component.scripts || []).map((src: string) =>
      loader(src.startsWith('http') ? src : `${staticServerURL}${src}`, AssetLoader.getTypes.SCRIPT)
    );

    const stylePromises = (component.styles || []).map((href: string) =>
      loader(`${staticServerURL}${href}`, AssetLoader.getTypes.STYLE)
    );

    loadedSet.add(name);
    return [...scriptPromises, ...stylePromises];
  });

  return Promise.all(
    assetPromises.map((promise) => promise.catch((err) => console.error('Error loading asset:', err)))
  );
};

export default loadComponents;
